import ReactECharts from 'echarts-for-react';
import echarts from '../echarts';
import { REVENUE_STRUCTURE } from '../data/mockData';

// 区块6：收入结构饼图
export default function ChartPieRevenue() {
  const colors = ['#fbbf24', '#06b6d4', '#22c55e', '#f97316'];
  const option = {
    backgroundColor: 'transparent',
    title: {
      text: '收入来源结构',
      left: 'center',
      textStyle: { color: '#fbbf24', fontSize: 20, fontWeight: 'bold' },
    },
    tooltip: {
      trigger: 'item',
      formatter: '{b}: {c}%',
      backgroundColor: 'rgba(15, 23, 42, 0.9)',
      borderColor: '#fbbf24',
      textStyle: { color: '#fff' },
    },
    legend: {
      orient: 'horizontal',
      bottom: 0,
      textStyle: { color: '#cbd5e1', fontSize: 14 },
    },
    series: [
      {
        name: '收入结构',
        type: 'pie',
        radius: '60%',
        center: ['50%', '50%'],
        itemStyle: {
          borderRadius: 6,
          borderColor: '#0f172a',
          borderWidth: 3,
        },
        label: {
          show: true,
          formatter: '{b}\n{c}%',
          color: '#fff',
          fontSize: 14,
          fontWeight: 'bold',
        },
        data: REVENUE_STRUCTURE.map((item, index) => ({
          ...item,
          itemStyle: { color: colors[index] },
        })),
        animationType: 'scale',
        animationEasing: 'elasticOut',
        animationDuration: 1200,
      },
    ],
  };

  return (
    <ReactECharts
      echarts={echarts}
      option={option}
      style={{ width: '100%', height: '100%', minHeight: 360 }}
      opts={{ renderer: 'svg' }}
    />
  );
}
